import FormTextarea from './FormTextarea'

export default FormTextarea



// WEBPACK FOOTER //
// ./src/components/Form/Textarea/index.js